import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import _Toast from "@kibt/meta-ui/es/toast";
import _slicedToArray from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { defineComponent, onMounted, reactive, toRefs, computed } from '@vue/composition-api';
import cookies from 'js-cookie';
import { useClipboard } from '@/common/use-clipboard';
import { isAndroid } from '@/common/device-info';
import { callApp } from '@/common/call-app';
import { sendLog, immediateSendLog, webLogger } from '@/common/log';
import imageBox from '@/components/image-box/index.vue';
import threshold from '@/components/threshold/index.vue';
import { format } from '@/common/foramt-invite-code';
import { appFullNameMap, countryPlatform, webLanguage, webCountry } from '@/common/const';
import { toLocaleString } from '@/common/util';
import { inviteShareData, fetchData } from './model';
import { getMessagesByCountry, getMessagesById } from '../invitation/model';
import { getLocale, getFishLangCode } from '@/config/language';
import { fetchABtest } from '../utils/index';
export default defineComponent({
  components: {
    imageBox: imageBox,
    threshold: threshold
  },
  filters: {
    format: format
  },
  setup: function setup(props, ctx) {
    var _ctx$root$$route, _share_id$toString$sp;

    var boostMessages = reactive({
      backgroundColor: '',
      backgroundImage: '',
      boostCode: '',
      button: '',
      canBoostButton: '',
      canBoostDesc: '',
      copyButton: '',
      copyToast: '',
      ended: '',
      finished: '',
      inviteTitle: '',
      step1: '',
      step2: '',
      step3: '',
      title: '',
      titlePaddingText: '',
      unit: '',
      userFinishedDesc: '',
      userInviteDescription: ''
    });

    var _ctx$root$$route$quer = (_ctx$root$$route = ctx.root.$route) === null || _ctx$root$$route === void 0 ? void 0 : _ctx$root$$route.query,
        cc = _ctx$root$$route$quer.cc,
        activity = _ctx$root$$route$quer.activity,
        fishId = _ctx$root$$route$quer.fishId,
        share_id = _ctx$root$$route$quer.share_id,
        sourcePlatform = _ctx$root$$route$quer.sourcePlatform,
        countryName = _ctx$root$$route$quer.countryInfo,
        share_uid = _ctx$root$$route$quer.share_uid,
        userId = _ctx$root$$route$quer.userId,
        share_item_type = _ctx$root$$route$quer.share_item_type,
        share_device_id = _ctx$root$$route$quer.share_device_id,
        language = _ctx$root$$route$quer.language;

    var userID = userId || share_uid;
    var country = Array.isArray(countryName) ? countryName[0] : countryName;
    var countryInfo = country === null || country === void 0 ? void 0 : country.toLowerCase();
    var shareIds = (_share_id$toString$sp = share_id === null || share_id === void 0 ? void 0 : share_id.toString().split('_')) !== null && _share_id$toString$sp !== void 0 ? _share_id$toString$sp : [];
    var languageCode = language || '';
    var webDid = cookies.get('_did') || cookies.get('did') || '';
    immediateSendLog({
      type: 'pv',
      name: 'HELP_INVITE_OUTH5',
      value: {
        type: isAndroid ? 'ANDROID' : 'IOS',
        share_channel: cc,
        share_activity: activity,
        share_id: share_id,
        fish_id: fishId,
        ua: window.navigator.userAgent,
        source_platform: sourcePlatform,
        share_item_info: 'refferalactivitydefault',
        share_uid: userID,
        share_item_type: share_item_type,
        share_timestamp: shareIds[(shareIds === null || shareIds === void 0 ? void 0 : shareIds.length) - 1],
        share_device_id: share_device_id,
        isBusinessCoreLog: true,
        page_url: window.location.href,
        abTest: 'base',
        webDid: webDid
      }
    });
    var appName = countryPlatform[countryInfo] || 'pro';
    var appFullName = appFullNameMap[appName];
    var isSnack = appName === 'snack';
    var state = reactive({
      isTouch: true,
      backgroundImage: '',
      backgroundColor: '',
      positionList: [],
      // 每次pv复制成功只上报一次success
      hasCopied: false,
      inviteDescription: '',
      wABtest: '',
      webDid: ''
    }); // const inviteShareModel = useApolloModel(InviteShareModel);

    var pointList = computed(function () {
      // 读取位置信息
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      state.positionList = inviteShareData.awardList.map(function (_, index) {
        return index * 100;
      });
      return inviteShareData.isGolds ? inviteShareData.awardList : inviteShareData.awardList.map(function (val) {
        return val / 100;
      });
    }); // 真实最大值

    var maxRealValue = computed(function () {
      var _inviteShareData$awar;

      return inviteShareData.awardList[((_inviteShareData$awar = inviteShareData.awardList) === null || _inviteShareData$awar === void 0 ? void 0 : _inviteShareData$awar.length) - 1];
    });
    var isReachMax = computed(function () {
      return inviteShareData.reward >= maxRealValue.value;
    });

    var cashFormat = function cashFormat(value) {
      if (!value) {
        return;
      }

      return inviteShareData.isGolds ? "".concat(toLocaleString(value), " ").concat(boostMessages.unit) : "".concat(inviteShareData.unit, " ").concat(toLocaleString(value / 100));
    }; // 手动触发绑定邀请码


    var handleInviteCodeCopy = function handleInviteCodeCopy(isCallApp) {
      if ((isCallApp || state.isTouch) && ctx.refs.copyButton) {
        state.isTouch = false;
        ctx.refs.copyButton.click();
      }
    };

    var initKrnEnable = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state.webDid = webDid;
                _context.next = 3;
                return fetchABtest({
                  did: webDid,
                  key: 'share_ab'
                });

              case 3:
                result = _context.sent;
                state.wABtest = result;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initKrnEnable() {
        return _ref.apply(this, arguments);
      };
    }();

    initKrnEnable();

    var handleCallAppClick = function handleCallAppClick() {
      if (isReachMax.value) {
        return;
      }

      handleInviteCodeCopy(true);
      var query = {
        webview: 'yoda',
        showLoading: 'true',
        needLogin: 'true',
        need_login: 'true',
        source: 'OUT_APP',
        inviteCode: inviteShareData.inviteCode || '',
        share_uid: userID || '',
        hyId: 'incentive_main',
        countryInfo: country,
        loginCheck: 1,
        __login_params__: JSON.stringify({
          scheme: 'ikwai://login',
          loginType: 1
        }),
        __launch_options__: JSON.stringify({
          topBarPosition: 'fixed',
          enableLoading: true,
          loadingType: 'incentive_h5'
        })
      };

      if (isSnack) {
        query = _objectSpread(_objectSpread({}, query), {}, {
          hideNavBar: 1
        }); // AB实验增加kds入口参数，如版本不支持不影响原有流程

        if (state.wABtest) {
          query.wABtest = state.wABtest;
          query.wABtest === 'exp_share' && (query.redirectUrl = encodeURIComponent("bundleId=Boost&componentName=Boost&themeStyle=1&source=OUT_APP&inviteCode=".concat(query.inviteCode, "&share_uid=").concat(query.share_uid, "&countryInfo=").concat(country, "&wABtest=").concat(state.wABtest, "&webDid=").concat(state.webDid)));
        }
      }

      query.webDid = state.webDid;
      var search = Object.entries(query).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return "".concat(key, "=").concat(encodeURIComponent(value));
      }).join('&');
      var url = "".concat(window.location.origin, "/").concat(isSnack && state.wABtest === 'exp_share' ? 'kds' : 'activity', "/boost?").concat(search);
      sendLog({
        type: 'click',
        name: 'HELP',
        value: {
          isBusinessCoreLog: true,
          page_url: window.location.href,
          to_url: url,
          wABtest: state.wABtest,
          webDid: state.webDid,
          abTest: 'base'
        }
      });
      var protocol = isSnack ? 'ikwaibulldog' : 'ikwai';
      var onlink = {
        me: 'https://kwaime.onelink.me/V16i/boost',
        pro: 'https://go.onelink.me/iGO2/boost',
        snack: 'https://snackinvitation.onelink.me/gUpo/boost'
      };
      var afSub1 = JSON.stringify({
        share_id: share_id,
        shareInfo: {
          target_url: location.href
        }
      });
      callApp({
        // 拉活归因链路中必需参数 调起客户端时 客户端会检测链接中是否有target_url参数
        path: "webview?url=".concat(encodeURIComponent(url), "&target_url=").concat(encodeURIComponent(location.href)),
        onelink: "".concat(onlink[appName], "?af_sub1=").concat(encodeURIComponent(afSub1)),
        protocol: protocol
      });
    };

    useClipboard({
      target: '.invite-code-button',
      clipboardOption: {
        text: function text() {
          return inviteShareData.inviteCode;
        }
      },
      successCallback: function successCallback() {
        _Toast.show({
          text: boostMessages.copyToast
        });

        if (state.hasCopied) {
          return;
        }

        state.hasCopied = true;
        sendLog({
          type: 'click',
          name: 'COPY_SUCCESS'
        });
      },
      errorCallback: function errorCallback() {
        sendLog({
          type: 'click',
          name: 'COPY_FAIL'
        });
      }
    });

    var getPreivewMessage = function getPreivewMessage(name) {
      var pageMap = {
        '/activity/invite-share': 'inviteShare',
        '/activity/share-invitation': 'inviteShare',
        '/activity/boost-share-invitation': 'landing'
      };
      var search = new URLSearchParams(location.search);
      var sharePageType = search.get('sharePageType');
      var messageName = pageMap[name];
      var messageStr = decodeURIComponent(search.get(messageName));

      try {
        var message = JSON.parse(messageStr);
        var pageTypeNum = +sharePageType;

        if (message) {
          if (pageTypeNum && messageName === 'inviteShare') {
            message["experiment-".concat(pageTypeNum)] = _objectSpread({}, message);
          }

          return message;
        }

        return {};
      } catch (error) {
        return {};
      }
    };

    var initPreviewPage = function initPreviewPage() {
      var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var previewPage = ['/activity/boost-share-invitation', '/activity/share-invitation', '/activity/invite-share'];
      var previewMessage;

      if (previewPage.includes(location.pathname)) {
        previewMessage = getPreivewMessage(location.pathname);
        messages = Object.assign(messages, previewMessage);
      }

      return {
        landing: messages
      };
    }; // 获取落地页样式和素材


    var getShareMessages = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var messagesRes, _webLogger$plugins, _webLogger$plugins$ra;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(fishId && /^\d+$/.test(String(fishId)))) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return getMessagesById({
                  fishId: Number(fishId),
                  language: getLocale(),
                  pageName: 'landing'
                });

              case 3:
                messagesRes = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.next = 8;
                return getMessagesByCountry({
                  path: window.location.pathname,
                  language: languageCode || getFishLangCode(webLanguage),
                  country: webCountry
                });

              case 8:
                messagesRes = _context2.sent;

              case 9:
                try {
                  webLogger === null || webLogger === void 0 ? void 0 : (_webLogger$plugins = webLogger.plugins) === null || _webLogger$plugins === void 0 ? void 0 : (_webLogger$plugins$ra = _webLogger$plugins.radar) === null || _webLogger$plugins$ra === void 0 ? void 0 : _webLogger$plugins$ra.fmp();
                } catch (error) {
                  console.error(error);
                }

                messagesRes = initPreviewPage(messagesRes.landing);
                boostMessages.title = messagesRes.landing.backgroundColor;
                boostMessages.backgroundColor = messagesRes.landing.backgroundColor;
                boostMessages.backgroundImage = messagesRes.landing.backgroundImage;
                boostMessages.boostCode = messagesRes.landing.boostCode;
                boostMessages.button = messagesRes.landing.button;
                boostMessages.canBoostButton = messagesRes.landing.canBoostButton;
                boostMessages.canBoostDesc = messagesRes.landing.canBoostDesc;
                boostMessages.copyButton = messagesRes.landing.copyButton;
                boostMessages.copyToast = messagesRes.landing.copyToast;
                boostMessages.ended = messagesRes.landing.ended;
                boostMessages.finished = messagesRes.landing.finished;
                boostMessages.inviteTitle = messagesRes.landing.inviteTitle;
                boostMessages.step1 = messagesRes.landing.step1;
                boostMessages.step2 = messagesRes.landing.step2;
                boostMessages.step3 = messagesRes.landing.step3;
                boostMessages.title = messagesRes.landing.title;
                boostMessages.titlePaddingText = messagesRes.landing.titlePaddingText;
                boostMessages.unit = messagesRes.landing.unit;
                boostMessages.userFinishedDesc = messagesRes.landing.userFinishedDesc;
                boostMessages.userInviteDescription = messagesRes.landing.userInviteDescription;
                document.title = boostMessages.title;
                state.backgroundImage = boostMessages.backgroundImage;
                state.backgroundColor = boostMessages.backgroundColor;
                state.inviteDescription = boostMessages.canBoostDesc.replace(new RegExp('{username}', 'g'), inviteShareData.nickName).replace(new RegExp('{reward}', 'g'), cashFormat(inviteShareData.activityReward)).replace(new RegExp('{appName}', 'g'), appFullName);

              case 35:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getShareMessages() {
        return _ref4.apply(this, arguments);
      };
    }();

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var status;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                userId: ctx.root.$route.query.userId || ctx.root.$route.query.share_uid
              });

            case 2:
              _context3.next = 4;
              return getShareMessages();

            case 4:
              status = '';

              if (inviteShareData.isEnded) {
                status = 'ACTIVITY_END';
              } else {
                status = isReachMax.value ? 'HELPED' : 'CAN_HELP';
              }

              sendLog({
                type: 'show',
                name: 'PAGE_STATUS',
                value: {
                  status: status,
                  isBusinessCoreLog: true
                }
              });
              window.addEventListener('scroll', function () {
                return handleInviteCodeCopy();
              });

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    return _objectSpread(_objectSpread({}, toRefs(state)), {}, {
      handleCallAppClick: handleCallAppClick,
      handleInviteCodeCopy: handleInviteCodeCopy,
      pointList: pointList,
      isReachMax: isReachMax,
      appFullName: appFullName !== null && appFullName !== void 0 ? appFullName : '',
      cashFormat: cashFormat,
      inviteShareData: inviteShareData,
      boostMessages: boostMessages
    });
  }
});